import { Injectable } from "@angular/core";

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const MENUITEMS = [
  {
    state: "home",
    name: "Dashboard",
    type: "link",
    icon: "dashboard",
    disabled: false,
  },
  {
    state: "new-application",
    name: "New Application",
    type: "link",
    icon: "library_add",
    disabled: false,
  },
  {
    state: "applications",
    name: "My Applications",
    type: "link",
    icon: "view_list",
    disabled: false,
  },
  {
    state: "profile",
    name: "Profile",
    type: "link",
    icon: "account_box",
    disabled: false,
  },
  {
    name: "Log Out",
    type: "link",
    icon: "exit_to_app",
    disabled: false,
  },
];

const EVALUATORMENUITEMS = [
  {
    state: "home",
    name: "Dashboard",
    type: "link",
    icon: "dashboard",
    disabled: false,
  },
  // {
  //   state: "applicants",
  //   name: "Applicants",
  //   type: "link",
  //   icon: "group",
  //   disabled: false,
  // },
  {
    state: "scheduling",
    name: "Scheduling",
    type: "link",
    icon: "calendar_month",
    disabled: false,
  },
  {
    state: "scanner",
    name: "Scanner",
    type: "link",
    icon: "qr_code_scanner",
    disabled: false,
  },
  {
    name: "Log Out",
    type: "link",
    icon: "exit_to_app",
    disabled: false,
  },
];

@Injectable()
export class MenuItems {
  getMenuitem(type): Menu[] {
    let menu = [];

    switch (type) {
      case "applicant":
        menu = MENUITEMS;
        break;
      case "evaluator":
        menu = EVALUATORMENUITEMS;
        break;
    }
    return menu;
  }
}
